export const WalkthroughStyle = {
  paperStyle: {
    width: "360px",
    height: "640px",
    borderRadius: "6px",
    overflow: "hidden",
  },
  dialogTitle: {
    background: "#fff",
    color: "#000",
  },
  titleBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  dialogBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    paddingBottom: "0",
    paddingTop: "0",
    width: "100%",
    height: "100%",
  },
  iframeStyle: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    // borderRadius: "6px",
  },

  closeIcon: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
};
